import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const REPORTS_API_PATH = '/api/reports';

const getDashboardScopeAccess = () => axios.get(`${API_BASE_URL}${REPORTS_API_PATH}/dashboard-scope`);
const getSalesSummary = (params = {}) => axios.get(`${API_BASE_URL}${REPORTS_API_PATH}/summary`, { params });
const getSalesOverTime = (params = {}) => axios.get(`${API_BASE_URL}${REPORTS_API_PATH}/sales-over-time`, { params });
const getTopProducts = (params = {}) => axios.get(`${API_BASE_URL}${REPORTS_API_PATH}/top-products`, { params });

const getSalesReport = (params = {}) => {
  return axios.get(`${API_BASE_URL}${REPORTS_API_PATH}/sales-report`, { params });
};

const getTillSessionsReport = (params = {}) => {
  return axios.get(`${API_BASE_URL}${REPORTS_API_PATH}/till-sessions`, { params });
};

const getTillSessionsReportTills = (params = {}) => {
  return axios.get(`${API_BASE_URL}${REPORTS_API_PATH}/till-sessions/tills`, { params });
};

const getStockReport = (params = {}) => {
  return axios.get(`${API_BASE_URL}${REPORTS_API_PATH}/stock`, {
    params,
    timeout: 15000,
  });
};

const getInventorySnapshots = (params = {}) => {
  return axios.get(`${API_BASE_URL}${REPORTS_API_PATH}/inventory-snapshots`, { params });
};

const reportsService = {
  getDashboardScopeAccess,
  getSalesSummary,
  getSalesOverTime,
  getTopProducts,
  getSalesReport,
  getTillSessionsReport,
  getTillSessionsReportTills,
  getStockReport,
  getInventorySnapshots,
};

export default reportsService;
